import React, { useState, useEffect } from 'react';
import { getErrorMessage } from '@utils/commons';
import { useErrors } from '@contexts/ErrorsContext';
import { AdvanceDecisonType } from '../../../utils';

interface AdrtUpdatedDateProps {
  advanceDecision: AdvanceDecisonType;
  setAdvanceDecision: React.Dispatch<React.SetStateAction<AdvanceDecisonType>>;
}

const AdrtUpdatedDate: React.FC<AdrtUpdatedDateProps> = ({
  advanceDecision,
  setAdvanceDecision,
}) => {
  const [adrtUpdatedDateErrMessage, setAdrtUpdatedDateErrMessage] = useState<
    string | undefined
  >('');
  const { errors } = useErrors();

  useEffect(() => {
    setAdrtUpdatedDateErrMessage(getErrorMessage(errors, 'adrtUpdatedDate'));
  }, [errors]);

  const handleDateChange = (field: 'day' | 'month' | 'year', value: string) => {
    setAdvanceDecision(prev => ({
      ...prev,
      updatedDate: { ...prev.updatedDate, [field]: value },
    }));
  };

  return (
    <div>
      <div
        className={`govuk-form-group ${adrtUpdatedDateErrMessage ? 'govuk-form-group--error' : ''}`}
      >
        <fieldset
          className="govuk-fieldset"
          role="group"
          aria-describedby="plan-updated-date-hint"
        >
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              Date the ADRT was last updated
            </h1>
          </legend>
          <div id="plan-updated-date-hint" className="govuk-hint">
            For example, 31 3 2026
          </div>
          {adrtUpdatedDateErrMessage && (
            <p id="full-name-input-error" className="govuk-error-message">
              <span className="govuk-visually-hidden">Error:</span>
              {adrtUpdatedDateErrMessage}
            </p>
          )}
          <div className="govuk-date-input__item">
            <div className="govuk-form-group">
              <label
                className="govuk-label govuk-date-input__label"
                htmlFor="adrtUpdatedDate"
              >
                Day
              </label>

              <input
                className={`govuk-input govuk-date-input__input govuk-input--width-2 ${adrtUpdatedDateErrMessage ? 'govuk-input--error' : ''}`}
                id="adrtUpdatedDate"
                name="adrtUpdatedDate"
                type="text"
                inputMode="numeric"
                maxLength={2}
                placeholder="DD"
                value={advanceDecision.updatedDate.day}
                onChange={e => {
                  const { value } = e.target;
                  if (/^[0-9]*$/.test(value) && value.length <= 2) {
                    handleDateChange('day', value);
                  }
                }}
              />
            </div>
          </div>
          <div className="govuk-date-input__item">
            <div className="govuk-form-group">
              <label
                className="govuk-label govuk-date-input__label"
                htmlFor="adrt-updated-date-month"
              >
                Month
              </label>
              <input
                className={`govuk-input govuk-date-input__input govuk-input--width-2 ${adrtUpdatedDateErrMessage ? 'govuk-input--error' : ''}`}
                id="adrt-updated-date-month"
                name="adrt-updated-date-month"
                type="text"
                inputMode="numeric"
                placeholder="MM"
                maxLength={2}
                value={advanceDecision.updatedDate.month}
                onChange={e => {
                  const { value } = e.target;
                  if (/^[0-9]*$/.test(value) && value.length <= 2) {
                    handleDateChange('month', value);
                  }
                }}
              />
            </div>
          </div>
          <div className="govuk-date-input__item">
            <div className="govuk-form-group">
              <label
                className="govuk-label govuk-date-input__label"
                htmlFor="adrt-updated-date-year"
              >
                Year
              </label>
              <input
                className={`govuk-input govuk-date-input__input govuk-input--width-4 ${adrtUpdatedDateErrMessage ? 'govuk-input--error' : ''}`}
                id="adrt-updated-date-year"
                name="adrt-updated-date-year"
                type="text"
                inputMode="numeric"
                placeholder="YYYY"
                maxLength={4}
                value={advanceDecision.updatedDate.year}
                onChange={e => {
                  const { value } = e.target;
                  if (/^[0-9]*$/.test(value) && value.length <= 4) {
                    handleDateChange('year', value);
                  }
                }}
              />
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default AdrtUpdatedDate;
